$(function () {
  $(".accordion").accordion({ firstActive: true });
})